/** @file Re-keys every deform key of a mesh after a topology plan (per-vertex offsets follow their vertices). */
import { meshOffsets } from '@pose2d/commands/animation/meshOffsets';
import type { CommandCall, Doc, Id } from '@pose2d/format/types';
import { blendSources, type TopologyPlan } from './blendSources';

/**
 * One `animation.setDeformKey` per non-null key of `attachment`: its full offsets (old vertex order, optionally mapped
 * by `convert` into the new rest space) rebuilt for the plan's sources. A rest (null) key stays as it is.
 */
export function deformRewrites(doc: Doc, attachment: Id, plan: TopologyPlan, oldCount: number, convert: ((full: number[]) => number[]) | null): CommandCall[] {
  const calls: CommandCall[] = [];
  for (const [animation, anim] of Object.entries(doc.animations)) {
    for (const key of anim.deform[attachment] ?? []) {
      if (key.offsets === null) continue;
      const full = meshOffsets.expand(key.offsets, 2 * oldCount);
      const values = blendSources.pairs(convert === null ? full : convert(full), plan.sources);
      calls.push({ name: 'animation.setDeformKey', input: { animation, attachment, frame: key.f, offsets: { start: 0, values } } });
    }
  }
  return calls;
}
